import ApiService from './ApiService';

const SettingsService = {
  get: () => ApiService.get('/settings'),
  update: (fields) => ApiService.patch('/settings', fields),
};

export default SettingsService;
